import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  TextField,
  Button,
  IconButton,
  Box,
  InputAdornment,
} from "@mui/material";
import {
  Close as CloseIcon,
  Person,
  Phone as PhoneIcon,
} from "@mui/icons-material";

import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../../theme";
import CustomTextField from "../../../../components/common/Textfield";

interface WhatsAppModalProps {
  open: boolean;
  onClose: () => void;
  whatsappNumber: string;
  onNumberChange: (value: string) => void;
  fullName: string;
  onFullNameChange: (value: string) => void;
  onSubmit: () => void;
}

const AddNumberModal: React.FC<WhatsAppModalProps> = ({
  open,
  onClose,
  whatsappNumber,
  onNumberChange,
  fullName,
  onFullNameChange,
  onSubmit,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <Box
        sx={{
          p: 3,
          bgcolor: colors.primary[500],
          color: "white",
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <PhoneIcon fontSize="large" />
          <Typography variant="h6" fontWeight="bold">
            Get Your Quote
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
          Enter your WhatsApp number to receive a Personalised quote
        </Typography>
      </Box>
      <DialogContent sx={{ p: 3, mt: 1 }}>
        {/* <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1.5 }}>
          WhatsApp Phone Number
        </Typography> */}
        <CustomTextField
          fullWidth
          label="Full Name"
          placeholder="e.g. John Doe"
          value={fullName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onFullNameChange(e.target.value)
          }
          // error={fullName.length > 0 && fullName.trim().split(" ").length < 2}
          // helperText={
          //   fullName.length > 0 && fullName.trim().split(" ").length < 2
          //     ? "Please enter your name and surname"
          //     : "Enter your full name"
          // }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "text.secondary" }} />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 3 }}
        />

        <CustomTextField
          fullWidth
          label="WhatsApp Number"
          placeholder="+263 77 123 4567"
          value={whatsappNumber}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onNumberChange(e.target.value)
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIcon sx={{ color: "text.secondary" }} />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 1 }}
        />

        <Typography variant="caption" sx={{ color: "text.secondary", mb: 4 }}>
          We'll send your Personalised quote via WhatsApp
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            sx={{
              py: 1.5,
              borderRadius: 2,
              color: "text.primary",
              borderColor: "divider",
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={onSubmit}
            sx={{
              py: 1.5,
              borderRadius: 2,
              background: `linear-gradient(135deg, ${colors.primary[500]} 0%, ${colors.primary[400]} 100%)`,
              color: "white",
            }}
          >
            Submit Request
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddNumberModal;
